import React, { Component } from "react";

import { Link } from "react-router-dom";
import qs from "qs";

class RecommendationCreate extends Component {
  state = {};
  render() {
    const style = { display: "contents", cursor: "pointer" };
    const hahstag = qs.stringify({ hashtag: this.props.hashtag }, "a=b");
    return (
      <Link style={style} to={"/create?" + hahstag}>
        <div className="create_recommendation_ratio recommendation_row_ratio cursor_btn">
          <label>
            <label
              className="image_media content-cover add-recommendation"
              alt=""
            />
            <ion-icon class="ion-icon" name="ios-add" />
          </label>
        </div>
      </Link>
    );
  }
}

export default RecommendationCreate;



// WEBPACK FOOTER //
// ./src/components/recommendation/recommendation_create.jsx